import { Utils } from '@gv/triage-components';

import { URL } from 'api/constants';
import { generateUrl } from 'utils/helpers';

import { apiInstance } from '../instance';

import { downloadXLSXRequest } from './types';

const { addParamsToUrl } = Utils.Query;

export const downloadXLSX = ({
  url,
  end,
  start,
  orderBy,
  direction,
  hospitalId,
  departmentId,
}: downloadXLSXRequest) => {
  const requestUrl = hospitalId ? generateUrl(url, { hospitalId }) : url;

  return apiInstance.get(
    addParamsToUrl(requestUrl, {
      end,
      start,
      orderBy,
      direction,
      departmentId,
    }),
    { responseType: 'blob' }
  );
};

export const getAppointmentDeclineReasons = ({
  end,
  start,
  hospitalId,
}: {
  end: string;
  start: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_CASES_NOT_BOOKED, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
    })
  );
};

export const getLineChartsData = ({
  end,
  start,
  hospitalId,
}: {
  end: string;
  start: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_LINE_CHARTS_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
    })
  );
};

export const getAppointmentConversionRateData = ({
  end,
  start,
  hospitalId,
}: {
  end: string;
  start: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_APPOINTMENT_CONVERSION_RATE_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
    })
  );
};

export const getAbandonedCallsData = ({
  end,
  start,
  hospitalId,
}: {
  end: string;
  start: string;
  hospitalId: string | number;
}) => {
  const url = generateUrl(URL.GET_ABANDONED_CALLS_DATA, {
    id: hospitalId,
  });

  return apiInstance.get(
    addParamsToUrl(url, {
      end,
      start,
    })
  );
};
